import { useDataFormStore } from "@/stores/form";
import { getArrayOfRules } from "@/utils/getDataForm";
import { inject } from 'vue';

export default {
  setup() {
    const dataForm = useDataFormStore();

    const ruleFormRef = inject('ruleFormRef', {})

    const optionsTypePowerOfAttorney = [
      {
        value: 1, //"Luch",
        label: 'ООО "УК ЛУЧ"',
      },
      {
        value: 2, //"Customer",
        label: "От заказчика",
      },
    ];

    const optionsWhoPaysTheRansom = [
      {
        value: "0",
        label: "За счёт средств клиента",
      },
      {
        value: "1",
        label: "За счет ТК ЛУЧ",
      },
    ];

    const communications = [
      {
        value: "Email",
        label: "Email",
      },
      {
        value: "Viber",
        label: "Viber",
      },
      {
        value: "WhatsApp",
        label: "WhatsApp",
      },
    ];

    function checkingDimensions(dimensions) {
      dimensions.sort((a, b) => b - a);
      return dimensions[0] > 100 || dimensions[1] > 70;
    }

    function isBoxesOnly() {
      return ![...dataForm.cargoInformation.typeOfPackaging].reduce(
        (prevtype, curtype) =>
          prevtype &&
          !(curtype.includes("Поддон") || curtype.includes("Паллетирование")),
        true
      );
    }

    return {
      dataForm,
      optionsTypePowerOfAttorney,
      optionsWhoPaysTheRansom,
      communications,
      getArrayOfRules,

      checkRedemption: function () {
        if (
          dataForm.services.whoPaysTheRansom === "1" &&
          Number(dataForm.services.cargoRedemptionSum) > 6000
        ) {
          dataForm.services.cargoRedemptionSum = 6000;
        }
      },

      toggleResetFields(value, propsToReset) {
        if (!value) {
          ruleFormRef.value.resetFields(propsToReset);
        }
      },

      checkDisabledWarmplace: function () {
        if (
          isBoxesOnly() ||
          Number(dataForm.cargoInformation.cargoVolume) > 0.5 ||
          dataForm.cargoInformation.cargoWeight > 30 ||
          checkingDimensions([
            dataForm.cargoInformation.cargoDimensions.length,
            dataForm.cargoInformation.cargoDimensions.width,
            dataForm.cargoInformation.cargoDimensions.height,
          ])
        ) {
          dataForm.services.warmPlace = false;
          return true;
        }
        return false;
      },
    };
  },
};
